export const getAuthUser = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    return null;
  }
  try {
    const payload = token.split('.')[1];
    if (!payload) {
      return null;
    }
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(normalized.length + (4 - (normalized.length % 4)) % 4, '=');
    const decoded = JSON.parse(atob(padded));
    return {
      role: decoded.role,
      userId: decoded.sub ?? null,
      employeeId: decoded.employeeId ?? null,
    };
  } catch {
    return null;
  }
};
